export default __webpack_public_path__ + "static/media/cryptoBig.fe8def16.jpeg";